import { render, staticRenderFns } from "./BabyInfo.vue?vue&type=template&id=4b37e323"
import script from "./BabyInfo.vue?vue&type=script&lang=js"
export * from "./BabyInfo.vue?vue&type=script&lang=js"
import style0 from "./BabyInfo.vue?vue&type=style&index=0&id=4b37e323&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports